import React from "react";

const NoDataFound = ({ message = "No Data Found" }) => {
  return (
    <section class="grSingle">
        <div maxwidth="lg" class="container">
            <div className="text-center py-5">
            <h3>{message}</h3>
            </div>
        </div>
    </section>
  );
};

export default NoDataFound;